<template>
  <c-box class="returns-wrapper" font-size="sm" :mx="{ base: '-md', md: 0 }">
    <!-- New product return process -->
    <c-box mt="4xl">
      <RMAProcessSteps />
      <c-box class="row">
        <c-box id="content-container" class="col-12 content-container">
          <RMARequestEditor />
        </c-box>
      </c-box>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RMARequestEditor from "@/views/rma/RMARequestEditor.vue";
import RMAProcessSteps from "@/views/rma/RMAProcessSteps.vue";
import { CBox } from "@chakra-ui/vue";

export default defineComponent({
  name: "NewReturn",
  components: {
    RMARequestEditor,
    RMAProcessSteps,
    CBox,
  },
});
</script>
